import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2681 11.1287C18.3685 10.9571 18.6315 10.9571 18.7319 11.1287L19.9396 13.1906C20.016 13.3211 20.1507 13.4125 20.3067 13.4397L22.7835 13.8716C22.99 13.9076 23.0716 14.144 22.9268 14.2866L21.1987 15.9886C21.0886 16.0972 21.0366 16.2466 21.0573 16.3952L21.3811 18.7193C21.4082 18.9138 21.1952 19.0595 21.0059 18.9759L18.7257 17.968C18.5828 17.9048 18.4172 17.9048 18.2743 17.968L15.9941 18.9759C15.8048 19.0595 15.5918 18.9138 15.6189 18.7193L15.9427 16.3952C15.9634 16.2466 15.9114 16.0972 15.8013 15.9886L14.0732 14.2866C13.9284 14.144 14.01 13.9076 14.2165 13.8716L16.6933 13.4397C16.8493 13.4125 16.984 13.3211 17.0604 13.1906L18.2681 11.1287Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2491 17.2367C12.2882 17.7247 11.1996 18 10.0463 18C6.15473 18 3 14.866 3 11C3 7.13401 6.15473 4 10.0463 4C13.2383 4 15.9345 6.10851 16.8008 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 11C11.1046 11 12 10.1046 12 9C12 7.89543 11.1046 7 10 7C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 14C8.20762 13.6561 9.02369 13 10 13C10.9763 13 11.7924 13.6561 12 14",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCrm);
export default ForwardRef;
